import React from 'react'

export default function Loader() {
  return (
    <div className="loadbody">

      <div class="spinner"></div>
    </div>
   


      
   
  )
}
